import {DatabaseViewType} from '../../../models/mongoose/DatabaseViewModel/enum/DatabaseViewType'
import {IconNameType} from '../../../enum/IconNameType'

export const DatabaseViewTypeToDefaultIconNameTypeMap = new Map<DatabaseViewType, IconNameType>([
  [DatabaseViewType.Table, IconNameType.Table],
  [DatabaseViewType.Map, IconNameType.MapMarkerAlt],
  [DatabaseViewType.Form, IconNameType.AlignJustify],
  [DatabaseViewType.Calendar, IconNameType.Calendar],
  [DatabaseViewType.Kanban, IconNameType.Columns3],
  [DatabaseViewType.IFrame, IconNameType.Anchor],
  [DatabaseViewType.Timeline, IconNameType.Stream],
])

